import apiService from '../apiService'

export const companyController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/company'

  return {
    getCompany: () => {
      return service.get({
        url: url,
      })
    },
  }
}

export const currencyExchangeRateController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/company_currency'

  return {
    getExchangeRate: (sort_by, sort_name) => {
      return service.get({
        url: url + '?sort_by' + '=' + sort_by + '&sort_name=' + sort_name,
      })
    },
  }
}

export const purchasingSiteController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/purchasing-company'

  return {
    getPurchasingSite: params => {
      return service.get({
        url: url + `?sort_by=${params.sort_by}&sort_name=${params.sort_name}`,
      })
    },
  }
}

export const companyProfileController = configService => {
  const service = apiService(configService)
  const url = 'cms/buyer/company-profile'

  return {
    updateCompanyProfile: params => {
      return service.put({
        url: url,
        params,
      })
    },
    getCurrency: () => {
      return service.get({
        url: `auth/buyer/currency`,
      })
    },
  }
}
